import React from 'react';
import { motion } from 'framer-motion';

// Simple SVG icons
const StarIcon = () => (
  <svg className="star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
  </svg>
);

interface TestimonialProps {
  content: string;
  author: string;
  role: string;
  delay: number;
}

const TestimonialCard: React.FC<TestimonialProps> = ({ content, author, role, delay }) => {
  return (
    <motion.div
      className="testimonial-card"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      viewport={{ once: true }}
    >
      <div className="rating">
        {[...Array(5)].map((_, i) => (
          <StarIcon key={i} />
        ))}
      </div>
      <p className="testimonial-content">{content}</p>
      <div className="testimonial-author">
        <div className="author-avatar">
          {author[0]}
        </div>
        <div>
          <div className="author-name">{author}</div>
          <div className="author-role">{role}</div>
        </div>
      </div>
    </motion.div>
  );
};

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      content: "LinguaSub полностью изменила мой подход к изучению испанского языка. Контекст из фильмов помогает словам лучше закрепляться в памяти.",
      author: "Елена Петрова",
      role: "Студентка, изучает испанский",
      delay: 0
    },
    {
      content: "Как преподаватель языка, я рекомендую Лингву всем своим студентам. Это увлекательный способ пополнять словарный запас через аутентичный контент.",
      author: "Михаил Лебедев",
      role: "Преподаватель",
      delay: 0.2
    },
    {
      content: "Персонализированные словари просто потрясающие! Обожаю, что могу учиться через любимые фильмы и получать удовольствие от процесса.",
      author: "Елена Иванова",
      role: "Студентка",
      delay: 0.3
    }
  ];

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title pencil-text">Отзывы пользователей</h2>
          <p className="section-description pencil-text">
            Присоединяйтесь к тысячам довольных студентов, которые ускоряют свой прогресс с Лингвой
          </p>
        </motion.div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard
              key={index}
              content={testimonial.content}
              author={testimonial.author}
              role={testimonial.role}
              delay={testimonial.delay}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 